import { useMutation } from "@tanstack/react-query";
import planetService from "../../services/planet-service";
import { useNavigate, useParams } from "react-router";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getCommunityDetails,
  setDoc,
} from "../../../../feature/community-slice/community-slice";
import {
  orbitParamValue,
  getPlanetParamPaylad,
  setQueryParams,
} from "../../../../utils/helper";
import {
  getOrbitDetails,
  setHeader,
  setSelectOrbit,
} from "../../../../feature/orbit-slice";
import CommunityDetails from "./community-details/community-details";
import { getCookie } from "../../../../utils/cookie";
import { useSearchParams } from "react-router-dom";
import SyPopup from "../../../../shared/components/sy-model";
import TimeLineFlagPop from "../../popups/timeLine-flag-popup";
import { setPlanetAccess, setPlanetData, setPlanetStatus } from "../../../../feature/planet-slice";

const CommunityScreen = (props: any) => {
  const { orbitId, planetId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const authToken = getCookie("auth_token");
  const communityDetail = useSelector(getCommunityDetails);
  const [timeLineData, setTimeLineData] = useState<any>([]);
  const [flagData, setFlagData] = useState<any>([]);
  const [openFlagPop, setOpenFlagPop] = useState<any>(false);
  const orbitInfo = useSelector(getOrbitDetails);
  const [searchParams] = useSearchParams();
  const [params, setParams] = useState<any>(orbitParamValue(searchParams));

  const updatePlanet = (type: any) => {
    if (type === "timeLine") {
      getTimeLineData();
    }else if(type==='close') {
      onClose()
    }
    else {
      getPlanet(planetId);
    }
  };

  const getTimeLineData = () => {
    if (planetId) {
      const payload = {
        pro_id: planetId,
      };
      getTimeLine(payload);
    }
  };


  // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // ++++++++++++++++++++++++++++++++++++++++++++USEMUTATION++++++++++++++++++++++++++++++++++++++++++++++++++
  // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++



  const { mutate: getPlanet, isPending: planetLoading } = useMutation({
    mutationFn: planetService.getPlanet,
    onSuccess(data, variables, context) {
      dispatch(setPlanetData(data.data))
      dispatch(setPlanetAccess(data.data.pro_access))
      getTimeLineData();
    },
  });


  const { mutate: getPlanetStatus } = useMutation({
    mutationFn: planetService.getPlanetStatus,
    onSuccess(data, variables, context) {
      dispatch(setPlanetStatus(data.data))
    },
  });


  const { mutate: getTimeLine } = useMutation({
    mutationFn: planetService.getTimeLine,
    onSuccess(data, variables, context) {
      setTimeLineData(data.data);
    },
  });
  const getFlagDetails = (planetId: any) => {
    const payload = {
      pro_id: planetId,
    };
    getFlagList(payload);
  };

  const flagCloseClick = () => {
    setOpenFlagPop(false);
  };
  const { mutate: getFlagList } = useMutation({
    mutationFn: planetService.getFlagList,
    onSuccess(data, variables, context) {
      setFlagData(data.data);
      setOpenFlagPop(data.data.length ? true : false);
    },
  });



  const onClose = () => {
    const timeout = setTimeout(() => {
       dispatch(setPlanetData(null))
      dispatch(setDoc(false));
      if (orbitInfo.adminStuff) {
        navigate({
          pathname: `/admin/${orbitId}/planets`,
          search: `?fr=${params.fr}`,
        });
      } else {
        navigate({
          pathname: "/orbit",
          search: `?fr=${params.fr}`,
        });
      }
      dispatch(setHeader(true));
      dispatch(setSelectOrbit(Number(orbitId)));
    }, 500);
    return () => clearTimeout(timeout);
  };

  useEffect(() => {
    getPlanet(planetId);
    getPlanetStatus();
    getFlagDetails(planetId);
    setQueryParams(
      getPlanetParamPaylad(
        communityDetail.timeLine && 1,
        communityDetail.doc && 1,
        params.fr
      )
    );
    dispatch(setHeader(false));
  }, [planetId]);

  return (
    <>
      <SyPopup open={openFlagPop} onClose={flagCloseClick} maxWidth={"sm"}>
        <TimeLineFlagPop
          flagData={flagData}
          handleCloseClick={flagCloseClick}
        />
      </SyPopup>
      <CommunityDetails
        timeLineData={timeLineData}
        updatePlanet={updatePlanet}
        onClose={onClose}
      />
    </>
  );
};

export default CommunityScreen;
